<template>
  <transition name="fade">
    <div v-if="modalActive" :class="'size-' + modalSize" class="base-modal">
      <div class="modal-body">
        <div class="close-icon" @click="closeModal">
          <font-awesome-icon icon="times" />
        </div>
        <div class="modal-header p-3">
          <h5 class="modal-heading">{{ modalTitle }}</h5>
        </div>
        <component :is="component" />
      </div>
    </div>
  </transition>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import TaxTypeModal from './TaxTypeModal'
import ItemModal from './ItemModal'
import EstimateTemplate from './EstimateTemplate'
import InvoiceTemplate from './InvoiceTemplate'
import CustomerModal from './CustomerModal'
import CategoryModal from './CategoryModal'
import PaymentMode from './PaymentModeModal'
import ItemUnit from './ItemUnitModal'
import MailTestModal from './MailTestModal'
import InvoiceAttachmentModal from './InvoiceAttachmentModal.vue'
import StakeholderModal from './StakeholderModal'
import ViewStakeholderModal from './ViewStakeholderModal'
import FinancialFacilityModal from './FinancialFacilityModal'
import ViewFinancialFacilityModal from './ViewFinancialFacilityModal'
import PrePaymentAttachmentModel from './PrePaymentAttachmentModel'
import DocumentModal from './DocumentModal'
import DocumentNoteModal from './DocumentNoteModal'
import ContactModal from './ContactModal'
import CashFlowValueInvoiceModal from './CashFlowValueInvoice'
import ImportItemFile from './ImportItemFileModal'
import PurchaseOrderTemplate from './PurchaseOrderTemplate'
import CurrencyModal from './CurrencyModal'
import OfferAmountModal from './OfferAmountModal'
import POAttachmentModal from './POAttachmentModal'
import DocumentTypeModal from './DocumentTypeModal'
import UserGuideModal from './UserGuideModal'
import ProcessDocumentModal from './ProcessDocumentModel'
import ImportPOFile from './ImportPOFileModal.vue'
import ImportInvoiceFile from './ImportInvoiceFileModal.vue'
import ImportPreapprovedInvoiceFile from './ImportPreapprovedInvoiceFileModal.vue'
import DynamicTemplateModal from './DynamicTemplateModal.vue'
import PreapprovedInvoiceAttachmentModal from './PreapprovedInvoiceAttachmentModal.vue'
import IslamicFinanceFormModal from './islamicFinanceModal/IslamicFinanceFormModal.vue'
import IslamicFinanceSendOfferModal from './islamicFinanceModal/SendOfferModal.vue'
import IslamicFinanceSendMyOfferModal from './islamicFinanceModal/SendMyOfferModal.vue'
import IslamicFinanceAttachmentModal from './islamicFinanceModal/IslamicFinanceAttachmentModal.vue'
import InvoicesBulkProcessingModal from './InvoicesBulkProcessingModal.vue'
import BulkPrePaymentProcessingModal from './BulkPrePaymentProcessingModal.vue'
import BulkSettleProcessingModal from './BulkSettleProcessingModal.vue'
import InvoicesBulkRequestModal from './InvoicesBulkRequestModal.vue'
import InvoicesRequestStatusChange from './InvoicesRequestStatusChange.vue'
import InvoicesSendToFunder from './InvoicesSendToFunder.vue'
import ImportPaymentPreapprovedInvoiceFileModal from './ImportPaymentPreapprovedInvoiceFileModal.vue'
import FormTemplateModal from './FormTemplateModal.vue'
export default {
  components: {
    TaxTypeModal,
    ItemModal,
    EstimateTemplate,
    InvoiceTemplate,
    CustomerModal,
    CategoryModal,
    PaymentMode,
    ItemUnit,
    MailTestModal,
    FormTemplateModal,
    InvoiceAttachmentModal,
    StakeholderModal,
    ViewStakeholderModal,
    FinancialFacilityModal,
    ViewFinancialFacilityModal,
    PrePaymentAttachmentModel,
    DocumentModal,
    DocumentNoteModal,
    ContactModal,
    CashFlowValueInvoiceModal,
    ImportItemFile,
    PurchaseOrderTemplate,
    CurrencyModal,
    OfferAmountModal,
    POAttachmentModal,
    DocumentTypeModal,
    UserGuideModal,
    ProcessDocumentModal,
    ImportPOFile,
    ImportInvoiceFile,
    ImportPreapprovedInvoiceFile,
    DynamicTemplateModal,
    PreapprovedInvoiceAttachmentModal,
    IslamicFinanceFormModal,
    IslamicFinanceSendOfferModal,
    IslamicFinanceAttachmentModal,
    InvoicesBulkRequestModal,
    InvoicesBulkProcessingModal,
    BulkPrePaymentProcessingModal,
    BulkSettleProcessingModal,
    InvoicesRequestStatusChange,
    InvoicesSendToFunder,
    ImportPaymentPreapprovedInvoiceFileModal,
    IslamicFinanceSendMyOfferModal
  },
  data () {
    return {
      component: '',
      hasFocus: false
    }
  },
  computed: {
    ...mapGetters('modal', [
      'modalActive',
      'modalTitle',
      'componentName',
      'modalSize',
      'modalData'
    ])
  },
  watch: {
    componentName (component) {
      if (!component) {
        return
      }

      this.component = component
    }
  },
  methods: {
    ...mapActions('modal', [
      'openModal',
      'closeModal'
    ])
  }
}
</script>
<style>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.base-modal .modal-body {
  max-width: 50%;
}
</style>
